import React from 'react';
import { normalizeTagValue, formatTagLabel } from '../utils/tagUtils';

const TagChip = ({
    label,
    value,
    isActive = false,
    isInteractive = false,
    onToggle,
    className = '',
    disabled = false,
}) => {
    const labelText = formatTagLabel(label);
    const valueText = value ?? normalizeTagValue(labelText);
    const combinedClassName = [
        'tag-chip',
        className,
        isActive ? 'tag-chip--active' : '',
        isInteractive ? 'tag-chip--interactive' : '',
        disabled ? 'tag-chip--disabled' : '',
    ].filter(Boolean).join(' ');

    const handleToggle = () => {
        if (!isInteractive || disabled) {
            return;
        }
        onToggle?.(valueText);
    };

    const activeAttr = isActive ? 'true' : 'false';

    if (isInteractive) {
        return (
            <button
                type="button"
                className={combinedClassName}
                data-tag={labelText}
                data-active={activeAttr}
                aria-pressed={isActive}
                onClick={handleToggle}
                disabled={disabled}
            >
                {labelText}
            </button>
        );
    }

    return (
        <span
            className={combinedClassName}
            data-tag={labelText}
            data-active={activeAttr}
        >
            {labelText}
        </span>
    );
};

export default TagChip;
